import "./App.css";
import Search from "./Search.js";
import WordOfTheDay from "./WordOfTheDay";

function App() {
  return (
    <div>
      <Search />
      <WordOfTheDay />
    </div>
  );
}

export default App;
